import ViewActive from './ViewActive';

export default ViewActive;
